exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#agenda-show-appointment .mb4px{margin-bottom:4px!important}#agenda-show-appointment .status-check{flex-grow:1}#agenda-show-appointment .status-check+.status-check{margin-left:23px}#agenda-show-appointment .whatsapp{display:flex;align-items:center;justify-content:center;transition:all .2s;color:var(--theme-grey);height:53.6px;text-decoration:none}#agenda-show-appointment .whatsapp:hover{color:var(--theme-color)}#agenda-show-appointment .whatsapp i{font-size:32px}#agenda-show-appointment .color-container{position:absolute;bottom:30px;left:0}#agenda-show-appointment .modal-dialog{max-width:960px!important}", ""]);

// exports
